/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Subtitle_Extract_Import_ActionInputs */



/**
* | output |
* | --- |
* | "Import ({count})" |
*
* @param {Subtitle_Extract_Import_ActionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_extract_import_action = /** @type {((inputs: Subtitle_Extract_Import_ActionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Extract_Import_ActionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Importer (${i?.count})`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Import (${i?.count})`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Importa (${i?.count})`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Импорт (${i?.count})`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Importar (${i?.count})`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`导入（${i?.count}）`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`インポート（${i?.count}）`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`आयात (${i?.count})`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Importar (${i?.count})`)
	return /** @type {LocalizedString} */ (`Import (${i?.count})`)
});